export class Deferred {
    constructor() {
        Object.defineProperty(this, "promise", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "resolve", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => null
        });
        Object.defineProperty(this, "reject", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => null
        });
        this.promise = new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    get then() {
        return this.promise.then.bind(this.promise);
    }
    get catch() {
        return this.promise.catch.bind(this.promise);
    }
}
//# sourceMappingURL=deferred.js.map